/**
 * Marca do troféu da UCC — SVG facetado, desenhado em código.
 *
 * Vetor em vez de render: escala sem borrar, herda o dourado dos tokens, pesa
 * poucos KB e não tem aquele acabamento de imagem gerada que denuncia a peça.
 * As facetas são triângulos assimétricos de propósito; simetria perfeita lê
 * como clipart.
 */

import type { SVGProps } from 'react';

export function TrophyMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 220 300" fill="none" role="presentation" {...props}>
      <defs>
        <linearGradient id="ucc-metal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--color-gold-bright)" />
          <stop offset="42%" stopColor="var(--color-gold)" />
          <stop offset="72%" stopColor="var(--color-gold-metal)" />
          <stop offset="100%" stopColor="var(--color-gold-deep)" />
        </linearGradient>
        <linearGradient id="ucc-metal-dark" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--color-gold-deep)" />
          <stop offset="100%" stopColor="var(--color-gold-shadow)" />
        </linearGradient>
      </defs>

      {/* Alças */}
      <path d="M46 44 L14 62 L18 118 L48 132 L44 100 L34 92 L32 70 L48 62 Z" fill="url(#ucc-metal-dark)" />
      <path d="M174 44 L206 62 L202 118 L172 132 L176 100 L186 92 L188 70 L172 62 Z" fill="url(#ucc-metal-dark)" />

      {/* Taça — facetas assimétricas */}
      <path d="M48 30 L110 18 L172 30 L164 118 L110 186 L56 118 Z" fill="url(#ucc-metal)" />
      <path d="M110 18 L172 30 L164 118 L110 186 Z" fill="url(#ucc-metal-dark)" opacity="0.55" />
      <path d="M74 44 L110 36 L110 158 L82 112 Z" fill="var(--color-gold-bright)" opacity="0.35" />
      <path d="M110 36 L146 44 L138 112 L110 158 Z" fill="var(--color-gold-shadow)" opacity="0.4" />

      {/* Haste e base */}
      <path d="M98 186 L122 186 L126 226 L94 226 Z" fill="url(#ucc-metal-dark)" />
      <path d="M66 226 L154 226 L164 258 L56 258 Z" fill="url(#ucc-metal)" />
      <path d="M48 258 L172 258 L172 284 L48 284 Z" fill="url(#ucc-metal-dark)" />
      <rect x="48" y="258" width="124" height="4" fill="var(--color-gold-bright)" opacity="0.5" />
    </svg>
  );
}

